export default function SkeletonCard() {
    return (
        <div className="animate-pulse">
            {/* Card Image Skeleton */}
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 h-64 rounded-lg mb-3"></div>

            {/* Card Name Skeleton */}
            <div className="bg-gray-700 h-4 rounded w-3/4 mb-2"></div>

            {/* Card Price Skeleton */}
            <div className="bg-gray-700 h-4 rounded w-1/2"></div>
        </div>
    );
}